const $ = jQuery.noConflict();

class ChangeProgram {
    constructor() {
        this.trigger = $('.program__list-link');
        this.prev = $('.program__left-trigger');
        this.next = $('.program__right-trigger');
        this.component = $('.program__component');
    }
    init() {
        this.trigger.on('click', this.changeProgram.bind(this));
        this.prev.on('click', this.prevProgram.bind(this));
        this.next.on('click', this.nextProgram.bind(this));
    }
    changeProgram(e) {
        e.preventDefault();
        const program = $(e.target).data('program');
        this.trigger.parent().removeClass('active');
        $(e.target).parent().addClass('active');
        this.component.fadeOut(200);
        $(`.program__component[data-program="${program}"]`).delay(200).fadeIn(200);
    }
    nextProgram() {
        const th = this;
        if ($('.program__list-single.active').next().length < 1) {
            $('.program__list-single').removeClass('active').first().addClass('active');
            th.component.fadeOut(200).first().delay(200).fadeIn(200);
        } else {
            $('.program__list-single.active').removeClass('active').next().addClass('active');
            $('.program__component:visible').fadeOut(200).next().delay(200).fadeIn(200);
        }
    }
    prevProgram() {
        const th = this;
        if ($('.program__list-single.active').prev().length < 1) {
            $('.program__list-single').removeClass('active').last().addClass('active');
            th.component.fadeOut(200).last().delay(200).fadeIn(200);
        } else {
            $('.program__list-single.active').removeClass('active').prev().addClass('active');
            $('.program__component:visible').fadeOut(200).prev().delay(200).fadeIn(200);
        }
    }
}

export default new ChangeProgram();
